import React, { memo } from 'react';
import EventPill from '../event-pill';
import { PillsContainer } from './event-pills-bar-styled';

const EventPillsBar = ({ events, activeEventIndex, onSelectEvent, isReviewSubmitted }) => {
  if (!events || events.length === 0) return null;

  return (
    <PillsContainer flexDirection="row" alignItems="center">
      {events.map((event, index) => (
        <EventPill
          key={event.id}
          event={event}
          index={index}
          isActive={index === activeEventIndex}
          onSelect={onSelectEvent}
          isReviewSubmitted={isReviewSubmitted}
        />
      ))}
    </PillsContainer>
  );
};

export default memo(EventPillsBar);
